<template>
  <div class="bodybox">
    <div class="body-l">
      <h3 class="tiele">{{fakeNews.title}}</h3>
      <div class="box" v-html="fakeNews.content">
      </div>
    </div>
    <div class="body-r">
      <h3 class="tiele">热门彩种</h3>
      <ul class="box" v-if="hotLotteryList.length>0">
        <li class="imgli" v-for="item in hotLotteryList" :key="item.lotteryCode">
          <router-link
            :to="'/lotterydetails?lotteryTypeCode='+item.lotteryTypeCode+'&lotteryCode='+item.lotteryCode"
          >
            <img v-if="item.iconCode" :src="_cdn + '/app/lottery_images/'+item.iconCode+'.png'" alt />
            <img v-else :src="_cdn + '/app/lottery_images/'+item.lotteryCode+'.png'" alt />
          </router-link>
          <router-link
            :to="'/lotterydetails?lotteryTypeCode='+item.lotteryTypeCode+'&lotteryCode='+item.lotteryCode"
          >{{item.lotteryName}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import mix from "~/mixins/news.mixins.vue";
import { APIgetNewsDetailById } from "@/service";

export default {
  mixins: [mix],
  data() {
    return {
      //CCTV新闻
      fakeNews: []
    };
  },
  computed: {
    _cdn() {
      return this.$store.getters['service/cdn']
    }
  },
  methods: {
    async getNewsDetailById(param) {
      const RES = await APIgetNewsDetailById(param);
      if (RES.code == "12200") {
        this.fakeNews = RES.data;
      }
    }
  },
  created(param) {
    const query = this.$route.query;
    this.getNewsDetailById(query);
  }
};
</script>
<style lang="less" scoped>
.bodybox {
  width: 1200px;
  margin: 0 auto;
  margin-top: 18px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  .body-l {
    width: 780px;
    background-color: #fff;
    padding: 30px 50px;
    .tiele{
      font-size: 28px;
      text-align: center;
    }
    .box {
      border-top: 1px #e6e6e6 solid;
      margin-top: 28px;
      padding: 18px;
    }
  }
  .body-r {
    width: 260px;
    background-color: #fff;
    padding: 20px;
    .box {
      border-top: 1px #e6e6e6 solid;
      margin-top: 15px;
      padding-top: 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .imgli {
        width: 105px;
        padding: 12px;
        a {
          display: block;
          color: #333;
          text-align: center;
          img {
            width: 80px;
          }
          &:hover {
            color: #ad1d32;
          }
        }
      }
    }
  }
  .tiele {
    font-size: 20px;
    font-weight: 500;
  }
}
</style>